import { AMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';

export default function genererFace() {
  return {
    code: '',
    etat: AMONTE,
    dateMontage: null,
    dateDemontage: null,
    faceMotifNonComId: '',
    declarableEnMairie: true,
    proposableReseau: true,
    proposableLc: true,
    actif: true,
    information: '',
  };
}
